import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown } from "lucide-react";

const faqs = [
  {
    q: "Hva er inkludert i standardprisen?",
    a: "Standardprisen inkluderer komplett badstue med HUUM Hive Mini 9 kW ovn, LED-belysning innvendig og utvendig, tregulv, glassdør, aspepanel, dampsperre, isolasjon og LYKKE löyly PAKKE (bøtte, øse, termometer, timeglass).",
  },
  {
    q: "Hva slags fundament kreves?",
    a: "CORTINA kan plasseres på flatt, stabilt underlag: betongplate, terrasse, steinlegging eller justerbare bunnrammer. Vi anbefaler en dreneringsløsning rundt badstuen.",
  },
  {
    q: "Kan jeg koble til strøm selv?",
    a: "Elektrisk tilkobling (230V/400V) skal utføres av autorisert elektriker. Vi leverer ferdig kabling frem til tilkoblingspunktet.",
  },
  {
    q: "Kan jeg tilpasse kledningen?",
    a: "Ja — standard er skandinavisk gran, men du kan velge Kebony, termotre eller malt kledning i valgfri RAL-farge.",
  },
  {
    q: "Hva er leveringstiden?",
    a: "Leveringstiden er normalt 6–8 uker fra bekreftet bestilling. Montering tar 1–2 dager.",
  },
];

export default function CortinaFaqAccordion() {
  const [open, setOpen] = useState(null);
  return (
    <div className="space-y-0 divide-y divide-foreground/10">
      {faqs.map((faq, i) => (
        <div key={i}>
          <button
            onClick={() => setOpen(open === i ? null : i)}
            className="w-full flex items-center justify-between py-5 text-left"
          >
            <span className="font-body text-2xl text-foreground pr-4">{faq.q}</span>
             <motion.span animate={{ rotate: open === i ? 180 : 0 }} transition={{ duration: 0.2 }}>
               <ChevronDown size={20} className="text-foreground/40 flex-shrink-0" />
             </motion.span>
            </button>
            <AnimatePresence>
             {open === i && (
               <motion.div
                 initial={{ height: 0, opacity: 0 }}
                 animate={{ height: "auto", opacity: 1 }}
                 exit={{ height: 0, opacity: 0 }}
                 transition={{ duration: 0.25 }}
                 className="overflow-hidden"
               >
                 <p className="pb-5 text-foreground/60 text-2xl leading-relaxed font-body">{faq.a}</p>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}
    </div>
  );
}